import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import * as echarts from 'echarts';
import { ref, onMounted } from 'vue';
export default {
  __name: 'pie',
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const props = __props;
    const ringChart = ref('');
    let echartData = [{
      value: 2154,
      name: '离线',
      itemStyle: {
        normal: {
          color: '#D4D4D4'
        }
      }
    }, {
      value: 3854,
      name: '正常',
      itemStyle: {
        normal: {
          color: '#0095FF'
        }
      }
    }, {
      value: 3515,
      name: '告警',
      itemStyle: {
        normal: {
          color: '#FFB200'
        }
      }
    }];
    let total_datas = 0;
    for (let i = 0; i < echartData.length; i++) {
      total_datas += echartData[i].value;
    }
    onMounted(() => {
      const myChart = echarts.init(ringChart.value);
      let option = {
        legend: {
          show: false
        },
        title: {
          text: total_datas,
          subtext: '设备总数',
          left: 'center',
          // 水平居中
          top: '41%',
          itemGap: 10,
          textStyle: {
            color: '#0C89FF',
            fontSize: 18
          },
          subtextStyle: {
            fontSize: 14,
            color: ['#415B73']
          }
        },
        series: [{
          name: '设备',
          type: 'pie',
          label: {
            normal: {
              show: false
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          radius: ['55%', '72%'],
          data: echartData
        }]
      };
      myChart.setOption(option, true);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "ring-chart",
        ref_key: "ringChart",
        ref: ringChart
      }, null, 512);
    };
  }
};